import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import type { IOrderTracking } from '../../../transactions-layout/models';

/**
 * Merchant-defined order status for a transaction.
 * Only rendered when the backend returns order tracking data for the
 * merchant (the feature is gated per merchant, server-side).
 */
@Component({
  standalone: false,
  selector: 'odin-order-tracking-card',
  templateUrl: './order-tracking-card.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './order-tracking-card.component.scss',
})
export class OrderTrackingCardComponent {
  @Input({ required: true }) orderTracking: IOrderTracking;
  @Input() updating: boolean = false;
  @Output() statusSelected = new EventEmitter<string>();

  public historyOpen: boolean = false;

  public get selectableStatuses(): string[] {
    return (this.orderTracking.availableStatuses || []).filter(
      (s) => s !== this.orderTracking.currentStatus,
    );
  }

  public toggleHistory(): void {
    this.historyOpen = !this.historyOpen;
  }

  public onStatusChange(event: Event): void {
    const select = event.target as HTMLSelectElement;
    const status = select.value;
    if (!status) return;
    select.value = ''; // reset so the same option can be re-picked after a failure
    this.statusSelected.emit(status);
  }
}
